import * as React from "react";
import {cs} from "../../../../../../../react/chain-services";
import "./step-4-finalize.scss";
import {scopedState} from "../../../../../../../react/scoped-state";
import {ListNameSection} from "../../common/list-name-section/list-name-section";
import {chain} from "../../../../../../../utils/fs";
import {SectionGroup} from "../../common/section-group";
import {cx} from "emotion";
import {Header} from "../../common/header/header";
import {UseState} from "../../../../../../../react/use-state";
import {InfoBlock} from "../../common/info-block/info-block";
import {AddressOptionsSection} from "./address-options-section/address-options-section";
import { AltNameTypeConfig } from "../../common/alt-name-type-config";

export const Step4Finalize = ({total, onBack, onComplete}) => cs(
    ["altNameType", (_, next) => AltNameTypeConfig({next})],
    ["state", ({altNameType}, next) => UseState({
        initValue: {
            name2Override: altNameType,
            nameOverride: ""
        },
        next,
    })],
    ["addAdditionalOptions", ({state}, next) => UseState({getInitValue: () => (["or_resident","or_occupant","or_homeowner"].indexOf(state.value.name2Override) !== -1), next})],
    ["assignNamesSection", ({state, addAdditionalOptions}, next) => AddressOptionsSection({
        state: scopedState(state, ["name2Override"]),
        nameOverride: scopedState(state, ["nameOverride"]),
        addAdditionalOptions,
        next,
    })],
    ["listNameSection", ({state}, next) => ListNameSection({
        data: scopedState(state, ["listName"]),
        xdQaName: "Demographics Search",
        next,
    })],
    ["sections", ({assignNamesSection, listNameSection}, next) => SectionGroup({
        sections: [
            assignNamesSection,
            listNameSection,
        ],
        next,
    })],
    ({assignNamesSection, listNameSection, sections, state}) => (
        <div className="step-4-finalize-0oq">

            {Header({
                icon: require("../../../../mailing-icons/listtype-demographics.png"),
                title: "Demographics Search",
                subTitle: "Create a list around demographic filters.",
            })}

            <div className="content">
                {InfoBlock({
                    content: <>
                        This targeted mailing list will appear as one of your available lists.{" "}
                        The first time you use it in an order, you will be charged.{" "}
                        <b>
                            Targeting parameters for new demographic lists will be stored for 24 hours.{" "}
                            If the first use of the mailing list doesn't occur within 24 hours, it will no longer be available for use.
                        </b>
                    </>,
                    xdQaName: "Demographics Search Use Info"
                })}

                {assignNamesSection.render({showErrors: sections.showErrors})}

                {listNameSection.render({
                    total,
                    showErrors: sections.showErrors,
                })}
            </div>

            <div className="footer">
                <button {...{
                    className: "cancel",
                    onClick: onBack,
                    "xd-qa-type": "button",
                    "xd-qa-name": "Demographics Search Back",
                }}>
                    Back
                </button>

                <button {...{
                    className: cx("next", {disabled: sections.invalid}),
                    disabled: sections.submitDisabled,
                    onClick: () => {
                        if(hj && typeof hj === 'function')
                        {
                            hj('event', `demographics_list_create_click_event`);
                        }
                        sections.submit(() => onComplete(state.value));
                    },
                    "xd-qa-type": "button",
                    "xd-qa-name": "Demographics Search Complete",
                }}>
                    Complete
                </button>
            </div>
        </div>
    )
);
